import { makeEnvironmentModel } from '../models/makeEnvironmentModel'

import { CenterSettingsStore } from './CenterSettingsStore'
import { ChecklistReportsStore } from './ChecklistReportsStore'
import { ChecklistsStore } from './ChecklistsStore'
import { FlightNetworkStore } from './FlightNetworkStore'
import { LoginStore } from './LoginStore'
import { MissionHistoryStore } from './MissionHistoryStore'
import { NavbarStore } from './NavbarStore'
import { UsersStore } from './UsersStore'
import { PartNumbersStore } from './PartNumbersStore'
import { DiscrepancyReportsStore } from './DiscrepancyReportsStore'

import type { Instance, SnapshotIn } from 'mobx-state-tree'
import { CommonSettingsStore } from './CommonSettingsStore'
import { NotificationStore } from './NotificationStore'
import { VehiclesStore } from './VehiclesStore'

export interface RootStoreModelEnvironment {}

const RootStoreModel = makeEnvironmentModel<RootStoreModelEnvironment>('RootStoreModel').props({
  notificationStore: NotificationStore,
  commonSettingsStore: CommonSettingsStore,
  navbarStore: NavbarStore,

  centerSettingsStore: CenterSettingsStore,
  loginStore: LoginStore,
  checklistReportsStore: ChecklistReportsStore,
  usersStore: UsersStore,
  missionHistoryStore: MissionHistoryStore,
  checklistsStore: ChecklistsStore,
  flightNetworkStore: FlightNetworkStore,
  partNumbersStore: PartNumbersStore,
  discrepancyReportsStore: DiscrepancyReportsStore,
  vehiclesStore: VehiclesStore,
})

type RootStoreModelType = typeof RootStoreModel

export interface RootStoreModelInstance extends Instance<RootStoreModelType> {}
export interface RootStoreModelSnapshotIn extends SnapshotIn<RootStoreModelType> {}

export interface WithMissionHistoryStore extends Pick<RootStoreModelInstance, 'missionHistoryStore'> {}
export interface WithCenterSettingsStore extends Pick<RootStoreModelInstance, 'centerSettingsStore'> {}
export interface WithNavBarStore extends Pick<RootStoreModelInstance, 'navbarStore'> {}
export interface WithChecklistReportsStore extends Pick<RootStoreModelInstance, 'checklistReportsStore'> {}
export interface WithLoginStore extends Pick<RootStoreModelInstance, 'loginStore'> {}
export interface WithUsersStore extends Pick<RootStoreModelInstance, 'usersStore'> {}
export interface WithChecklistsStore extends Pick<RootStoreModelInstance, 'checklistsStore'> {}
export interface WithVehiclesStore extends Pick<RootStoreModelInstance, 'vehiclesStore'> {}
export interface WithFlightNetworkStore extends Pick<RootStoreModelInstance, 'flightNetworkStore'> {}
export interface WithCommonSettingsStoreStore extends Pick<RootStoreModelInstance, 'commonSettingsStore'> {}
export interface WithNotificationStore extends Pick<RootStoreModelInstance, 'notificationStore'> {}
export interface WithPartNumbersStore extends Pick<RootStoreModelInstance, 'partNumbersStore'> {}
export interface WithDiscrepancyReportsStore extends Pick<RootStoreModelInstance, 'discrepancyReportsStore'> {}

export function createRootStoreModel(
  rootStoreModelSnapshot: RootStoreModelSnapshotIn,
  rootStoreModelEnvironment: RootStoreModelEnvironment,
): RootStoreModelInstance {
  return RootStoreModel.create(rootStoreModelSnapshot, rootStoreModelEnvironment)
}

export interface WithRootStore {
  store: RootStoreModelInstance
}
